module.exports = __webpack_public_path__ + "img/center.bf616804.png";